<ng-container  *ngIf="info?.isActive !== null ? info.isActive : false">
    <button mat-icon-button (click)="showQuill($event)" class ="flex items-center">
        <mat-icon class="icon-size-6" svgIcon="heroicons_solid:information-circle"></mat-icon>
    </button>
 </ng-container> 